module.exports = __webpack_public_path__ + "pagamento.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/pagamento.png
 ** module id = 754
 ** module chunks = 0
 **/